import React, { useState } from 'react';
import Product from '../../Types/Product';
import RoundedPlusButton from '../RoundedPlusButton';
import ProductsModal from '../ProductsModal/ProductsModal';

interface MediaBlockProductsButtonProps {
  products: Product[];
}

const MediaBlockProductsButton = ({
  products,
}: MediaBlockProductsButtonProps) => {
  const [productsOpen, setProductsOpen] = useState(false);
  return (
    <>
      <RoundedPlusButton
        onClick={() => setProductsOpen(!productsOpen)}
        className="absolute bottom-2 right-2 lg:bottom-4 lg:right-4"
      />
      <ProductsModal
        open={productsOpen}
        onClosed={() => setProductsOpen(false)}
        products={products}
        className="md-down:max-h-[50%]"
      />
      <button
        onClick={() => setProductsOpen(!productsOpen)}
        className="absolute bottom-0 left-0 right-0 top-0 z-10 cursor-pointer"
      ></button>
    </>
  );
};

export default MediaBlockProductsButton;
